module.exports = __webpack_public_path__ + "img/user-icon.d456fcc2.png";